import { createReducer, createAction } from '@reduxjs/toolkit';
import { getHeaderData } from '../actions/headerData';

export const setHeaderCache = createAction('header/setCache');

const initialState = {
  loadingHeader: true,
  headerData: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getHeaderData.fulfilled, (state, action) => ({
      ...state,
      headerData: action.payload,
      loadingHeader: false,
    }))
    .addCase(setHeaderCache, (state, action) => ({
      ...state,
      headerData: action.payload,
      loadingHeader: false,
    }));
});
